import { render } from "./T&C.vue?vue&type=template&id=5588161a&scoped=true&ts=true"
import script from "./T&C.vue?vue&type=script&lang=ts"
export * from "./T&C.vue?vue&type=script&lang=ts"

import "./T&C.vue?vue&type=style&index=0&id=5588161a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5588161a"]])

export default __exports__